import { Dialog, DialogContent, DialogTitle, Tab, Tabs } from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
import { noop } from '@thalesrc/js-utils';
import React, { useContext, useState } from 'react';

import { exportVaccines, getVaccines } from '../../../../api/hs/dashboard/widget/widget';
import { DateRange } from '../../../../api/hs/dashboard/widget/widget.payload';
import IndicatorWrapper from '../../../../Common/IndicatorWrapper';
import { useFetch } from '../../../../utils';
import colors from '../../colors';
import { DialogContext } from '../../dialog.context';
import Header from '../Header';
import VaccineTable from './VaccineTable';

const fileNames = { neared: 'asi-yaklasan.xlsx', missed: 'asi-gecen.xlsx' };

export default () => {
  const [tab, setTab] = useState<string>('neared');
  const [loading, setLoading] = useState<boolean>(false);

  const { data: missed } = useFetch(() => getVaccines(new DateRange(null, new Date())), [], { setLoading });
  const { data: neared } = useFetch(() => getVaccines(new DateRange(dateRange?.start, dateRange?.end)), [], { setLoading });

  const tabs = { neared, missed };

  const {
    vaccine: { close, opened },
    vaccineDateRange: { dateRange },
  } = useContext(DialogContext);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: any) => {
    setTab(newValue);
  };

  const handleExcelExport = () => {
    if (tab === 'neared') {
      exportVaccines(new DateRange(dateRange.start, dateRange.end), fileNames[tab]).then(noop);
      return;
    }

    if (tab === 'missed') {
      exportVaccines(new DateRange(dateRange.start, dateRange.end), fileNames[tab]).then(noop);
    }
  };

  return (
    <TabContext value={tab.toString()}>
      <Dialog open={opened} onClose={close} fullWidth maxWidth="md">
        <Header title="Aşı" color={colors.vaccine} onClick={tabs[tab].length > 0 && handleExcelExport} />
        <DialogTitle>
          <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example">
            <Tab wrapped label={`Aşı Vakti Gelen (${neared.length})`} value={'neared'} />
            <Tab wrapped label={`Aşı Vakti Geçen (${missed.length})`} value={'missed'} />
          </Tabs>
        </DialogTitle>
        <DialogContent style={{ height: '300px' }}>
          <TabPanel value={'neared'}>
            <IndicatorWrapper data={neared} loading={loading} errorMessage="Listelenecek Kayıt Bulunamadı">
              <VaccineTable users={neared} />
            </IndicatorWrapper>
          </TabPanel>
          <TabPanel value={'missed'}>
            <IndicatorWrapper data={missed} loading={loading} errorMessage="Listelenecek Kayıt Bulunamadı">
              <VaccineTable users={missed} />
            </IndicatorWrapper>
          </TabPanel>
        </DialogContent>
      </Dialog>
    </TabContext>
  );
};
